import { Reveal, SectionLabel } from "../components/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Raccontaci il tuo progetto",
    text: "Compila il modulo spiegando la tua attività, le esigenze e le eventuali funzionalità richieste.",
  },
  {
    n: "02",
    title: "Valutiamo insieme la soluzione",
    text: "Analizziamo la richiesta e definiamo insieme struttura, caratteristiche e funzionalità. Il confronto può avvenire via email, telefono o videochiamata.",
  },
  {
    n: "03",
    title: "Prima bozza gratuita",
    text: "Prepariamo una prima proposta visiva personalizzata per permetterti di valutare concretamente stile e direzione del progetto.",
    note: "La prima bozza gratuita è una proposta iniziale limitata: non corrisponde alla realizzazione gratuita dell'intero sito.",
  },
  {
    n: "04",
    title: "Approvazione e avvio",
    text: "Se la proposta convince, concordiamo progetto, condizioni, costo, tempistiche ed eventuali revisioni comprese. Dopo l'accordo viene richiesto un primo acconto.",
  },
  {
    n: "05",
    title: "Realizzazione, revisione e controllo finale",
    text: "Completiamo il progetto, lo verifichiamo insieme e apportiamo le modifiche concordate prima della pubblicazione.",
  },
  {
    n: "06",
    title: "Saldo, pubblicazione e consegna",
    text: "Dopo l'approvazione finale viene completato il saldo, il sito viene pubblicato e ricevi gli accessi necessari alla gestione della tua infrastruttura.",
  },
];

export const Process = () => (
  <section id="come-lavoriamo" aria-labelledby="process-title" className="bg-white">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-28">
      <Reveal className="max-w-3xl">
        <SectionLabel>Come lavoriamo</SectionLabel>
        <h2 id="process-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-navy-dark sm:text-4xl">
          Dal primo contatto alla pubblicazione.
        </h2>
      </Reveal>
      <ol className="relative mt-14 space-y-0 border-l border-line pl-0 sm:ml-4">
        {STEPS.map((step, i) => (
          <li key={step.n} className="relative">
            <Reveal delay={Math.min(i * 0.05, 0.25)}>
              <div className="flex gap-6 pb-12 sm:gap-10">
                <div className="relative flex flex-col items-center">
                  <span className="z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-celeste/40 bg-white font-display text-sm font-bold text-navy shadow-sm sm:-ml-6">
                    {step.n}
                  </span>
                  {i < STEPS.length - 1 && (
                    <span className="absolute top-12 h-full w-px bg-line" aria-hidden="true" />
                  )}
                </div>
                <div className="pb-2 pt-1.5">
                  <h3 className="font-display text-lg font-semibold text-navy-dark sm:text-xl">{step.title}</h3>
                  <p className="mt-2 max-w-2xl text-sm leading-relaxed text-steel sm:text-base">{step.text}</p>
                  {step.note && (
                    <p className="mt-3 max-w-2xl rounded-lg border-l-2 border-celeste bg-celeste-soft/60 px-4 py-3 text-xs leading-relaxed text-navy sm:text-sm">
                      {step.note}
                    </p>
                  )}
                </div>
              </div>
            </Reveal>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
